import { Directive, ElementRef, OnInit, Output, EventEmitter } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[googlePlace]'
})
export class GooglePlaceDirective implements OnInit {
  @Output() public placeChanged: EventEmitter<google.maps.places.PlaceResult> = new EventEmitter();
  public autoComplete: google.maps.places.Autocomplete;

  constructor(private el: ElementRef,
              private mapsAPILoader: MapsAPILoader,
              private ngControl: NgControl) {
  }

  private init() {
    this.autoComplete = new google.maps.places.Autocomplete(this.el.nativeElement, {
      types: ['address'],
      componentRestrictions: {country: 'us'}
    });

    this.autoComplete.addListener('place_changed', () => {
      try {
        // console.log(this.autoComplete.getPlace());
        // this.ngControl.control.setValue(this.autoComplete.getPlace().formatted_address);
      } catch (e) {
        console.log(e);
      }

      this.placeChanged.emit(this.autoComplete.getPlace());
    });
  }

  ngOnInit() {
    if (window && window['google']) {
      this.init();
    } else {
      this.mapsAPILoader.load().then(() => {
        this.init();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/google.places.directive.ts